const PostGaAnalytics = (typeEvet, objParams) => {
  if (typeEvet === 'send') {
    window.gtag('event', 'send', objParams);
  } else {
    window.gtag(typeEvet, objParams);
  }
};

export default PostGaAnalytics;
